import dayjs from "dayjs";

export const emailToAddress = (mortgage) => {
    let arr = [mortgage.applicant1.email]
    if (mortgage.twoApplicants && mortgage.applicant2.email){
        arr.push(mortgage.applicant2.email)
    }
    return arr
}
export const emailSalutation = (mortgage) => {
    if (mortgage.twoApplicants){
        if (mortgage.applicant2.firstName) {
            return `Hi ${mortgage.applicant1.firstName} and ${mortgage.applicant2.firstName}`
        }
    }
    return `Hi ${mortgage.applicant1.firstName}`
}

export const lenderMortgageSubjectLine = (mortgage)=>{
    return `Account: ${mortgage.activeSubmission.mortgageAccountNo} / ${mortgage.applicationTitle}`
}
export function postProcessEmail (html){
    return html
        .replace(/<figure class="table">/g, '')
        .replace(/<\/figure>/g, '');
}

export function emailHeading(text, level = 4) {
    const tag = `h${level}`
    return `<${tag}><span style="color:#0083c1;">${text}</span></${tag}>`
}

class TableRow {
    constructor({
                    type= "row",
                    cellsDefaultStyles={}
    } = {}) {
        this.type = type
        this.cells = []
        this.cellStyles = []
        this.cellsDefaultStyles=cellsDefaultStyles
    }

    addCell(content, style = {}) {
        this.cells.push(content)
        this.cellStyles.push({...this.cellsDefaultStyles, ...style})
        return this
    }
}



export const sussdColor = '#006272'

export class EmailTable {
    constructor({layout=false, cols, backgroundColor = "#f9f9f9", border = `1px solid ${sussdColor}` } = {}) {
        this.rows = []
        this.backgroundColor = !layout ? backgroundColor: "transparent"
        this.border = !layout ? border : "none"
        this.tableTitle = null
        this.cols = cols
        this.layout = layout
    }

    createRow(props) {
        const row = new TableRow(props)
        this.rows.push(row)
        if (!this.cols){
            let w = 24 / row.cells.length
            this.cols = [...Array(row.cells.length).fill(w) ]
        }
        return row
    }

    title(str){
        this.tableTitle = str
        return this
    }
    createHeader() {
        const row = new TableRow({type:"header"})
        this.rows.push(row)
        return row
    }
    renderCell(content, type = "td", styles = {}) {
        const style = {
            padding: "12px 8px",
            textAlign: "left",
            ...styles,
        }
        const styleStr = Object.entries(style||{})
            .map(([k, v]) => `${k.replace(/[A-Z]/g, m => "-" + m.toLowerCase())}:${v}`)
            .join(";")
        return `<${type} style="${styleStr}">${content}</${type}>`
    }

    render() {
        const roundedCorners = this.layout ? '':` border-radius:12px; overflow:hidden;`
        const colWidths = this.cols.map(c => (c / this.cols.reduce((a, b) => a + b, 0) * 100).toFixed(2) )
        const tableClass = this.layout ? "layout-table" : "content-table"
        const collapsed = this.layout ? "border-collapse: collapse;": ""
        const tableStyle = `border: ${this.border}; ${collapsed} background-color: ${this.backgroundColor}; width:100%; margin: 20px 0; ${roundedCorners}`
        let html = `<table class="table ${tableClass}" style="${tableStyle}">`
        html += `<colgroup>${colWidths.map(w => `<col style="width:${w}%;">`).join('')}</colgroup>`
        const colspan = this.rows[0]?.cells.length || 1
        if (this.tableTitle){
            html += `<thead><tr><th colspan="${colspan}" style="padding: 12px 8px; text-align: left;">  <span style="color: ${sussdColor}"> ${this.tableTitle} </span> </th></tr></thead>`
        }
        html += "<tbody>"
        for (const row of this.rows) {
            html += "<tr>"
            row.cells.forEach((cell, index) => {
                const type = row.type === "header" ? "th" : "td"
                html += this.renderCell(cell, type, row.cellStyles[index])
            })
            html += "</tr>"
        }
        html += "</tbody>"
        html += "</table>"
       return html
    }
}

export function EmailList(items, { margin = "16px 0", paddingLeft = "20px", fontSize = "14px", lineHeight = "20px", disc=true } = {}) {
    const listStyle = `
    margin:${margin};
    padding-left:${paddingLeft};
    font-size:${fontSize};
    line-height:${lineHeight};
    ${disc ? 'list-style-type:disc;':'list-style-type:none;'}
    list-style-position:outside;
  `.replace(/\s+/g, " ")

    const liStyle = `
    margin:4px 0;
    padding:0;
  `.replace(/\s+/g, " ")

    const html = `
    <ul style="${listStyle}">
      ${items.map(item => `<li style="${liStyle}">${item}</li>`).join("")}
    </ul>
  `
    return html
}

export function ErrorSpan(err) {

    return `<span style="color:#b40c0c; padding-right: 4px">✖️</span>${err}`
}

export function LinkToSignIn(str) {
    return `<a href="https://apply.sussd.ie/sign-in" target="_blank" style="padding: 9px 12px; background-color: #006272; color: #ffffff; text-decoration: none; border-radius: 4px;">${str} </a>`
}

export const dayjsBusiness = (dateString, addDays) => {
    let date = dateString
    if (!dayjs.isDayjs(date)){
        date = dayjs(dateString)
    }
    date = date.hour(9).minute(0);
    if (addDays) {
        date = date.add(addDays, 'day');
    }
    if (date.day() === 6) {
        return date.add(2, 'day');
    }
    if (date.day() === 0) {
        return date.add(1, 'day');
    }
    return date;
}